import { mediaData } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          精选推荐
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12 max-w-[600px] mx-auto">
          糖心视频、黑桃视频、妖精视频精彩内容每日更新，手机看视频移动端播放更流畅
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {mediaData.map((item) => (
            <div key={item.id} className="group relative bg-background-50 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:border-primary-200/60">
              <div className="relative aspect-video overflow-hidden bg-background-100">
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-semibold text-background-50 bg-primary-500/90 rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3 flex items-center gap-1.5 px-2.5 py-1 bg-black/60 rounded-full">
                  <i className="ri-play-circle-line text-background-50 text-xs"></i>
                  <span className="text-xs text-background-50 font-medium">{item.duration}</span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-14 h-14 flex items-center justify-center bg-primary-500/90 rounded-full cursor-pointer">
                    <i className="ri-play-fill text-background-50 text-2xl"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 line-clamp-1">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}